import React, { useState, useEffect } from "react";
import { Button, Collapse, Input, Label } from "reactstrap";
import { getSettingByKey } from "../../../../helpers/common";
import { useSelector } from "react-redux";

const CandidateStatus = ({
  onFilterChange,
  handleClearFilter,
  searchParams,
}) => {
  const [toggleThird, setToggleThird] = useState(false);
  const [checked, setChecked] = useState([]);

  // ✅ Read multi-select strings from URL query params
  let gender = searchParams.get("gender");

  // ✅ Pull global settings array directly from Redux Store matching your reference architecture
  const settings = useSelector((state) => state.settings.data);

  // ✅ Helper function to turn strings safely into split arrays matching reference
  const toArray = (str, delim) =>
    str
      ? str
          .split(delim)
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

  // ✅ Extract and parse "Gander" settings value synchronously using Redux state
  const genderOptionsList = toArray(
    getSettingByKey(settings, "Gander")?.value,
    "\n",
  ).filter((opt) => opt.toLowerCase() !== "any"); // Skip "Any" option since "All Gender" checkbox handles it

  // ✅ Synchronize checkboxes with comma-separated URL values on load/refresh
  useEffect(() => {
    if (gender) {
      setChecked([gender]);
    } else {
      setChecked([]);
    }
  }, [gender]);

  // ✅ Multi-Select Checkbox Click Action Handler
  const handleToggle = (value) => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });

    // If the same option is clicked again, clear it
    if (checked.includes(value)) {
      setChecked([]);
      handleClearFilter("gender");
    } else {
      // Keep only one selected value
      setChecked([value]);
      onFilterChange("gender", value);
    }
  };

  return (
    <div className="accordion-item border rounded-3 shadow-sm overflow-hidden mb-3 mt-3">
      <h2 className="accordion-header" id="jobType">
        <Button
          className={`accordion-button fw-bold bg-white text-dark py-3 px-4 shadow-none d-flex justify-content-between align-items-center ${
            toggleThird ? "" : "collapsed"
          }`}
          onClick={(e) => {
            e.preventDefault();
            setToggleThird(!toggleThird);
          }}
          role="button"
          id="collapseExample"
        >
          <span>Sort By Genders</span>
          {checked.length > 0 && (
            <span className="badge bg-soft-primary text-primary rounded-pill fs-12 px-2 py-1 me-3">
              {checked.length} Selected
            </span>
          )}
        </Button>
      </h2>

      <Collapse isOpen={toggleThird}>
        <div className="accordion-body bg-white p-4 pt-2">
          <div className="side-title">
            {/* --- All Options / Clear Selection --- */}
            <div className="form-check d-flex align-items-center py-1 rounded transition-all">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="genderAll"
                checked={checked.length === 0}
                onChange={() => {
                  setChecked([]);
                  handleClearFilter("gender");
                }}
              />
              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.length === 0 ? "text-dark fw-semibold" : "text-muted"
                }`}
                htmlFor="genderAll"
              >
                Any
              </Label>
            </div>

            {/* --- Dynamic Checkbox Render Loop from Redux --- */}
            {genderOptionsList?.map((gender, index) => {
              const lowerValue = gender.toLowerCase();
              const isSelected = checked.includes(lowerValue);

              return (
                <div
                  key={`gender-filter-${index}`}
                  className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all"
                >
                  <Input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    id={`gender-${lowerValue}`}
                    checked={isSelected}
                    onChange={() => handleToggle(lowerValue)}
                  />
                  <Label
                    className={`form-check-label ms-2 cursor-pointer w-100 ${
                      isSelected ? "text-dark fw-semibold" : "text-muted"
                    }`}
                    htmlFor={`gender-${lowerValue}`}
                  >
                    {gender}
                  </Label>
                </div>
              );
            })}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CandidateStatus;
